<div class="device"
[ngStyle]="{ 'font-size.px': deviceSize }"
>
  <span>Апарат експертного класу</span>
  <span>GE VOLUSON S8</span>
</div>
